import { Component, OnInit } from '@angular/core';
import { finalize, take } from 'rxjs/operators';
import { SeguroServices } from 'src/app/services/seguro/seguro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { UtilService } from 'src/app/services/util.service';


@Component({
    selector: 'app-meus-seguros',
    templateUrl: './meus-seguros.component.html',
    styleUrls: ['./meus-seguros.component.css'],
    imports: [CommonModule, DatePipe, CurrencyPipe]
})
export class MeusSegurosComponent implements OnInit {

  lista: any[] = [];

  constructor(private utilService: UtilService, private seguro: SeguroServices, private toastr: ToastrService) { }

  ngOnInit() {
    this.listar();
  }

  listar(){

    this.seguro
        .ListaContratados()
        .pipe(
          take(1)
        )
        .subscribe(
          (res) => {
            this.lista = res;
          }
        );
  }

  baixarCertificado(codPart: number, codSeguro: number, row: any){

    row.loading = true;

    this.seguro
        .BaixarArquivoCertificado(codPart, codSeguro)
        .pipe(
          finalize(()=> { row.loading = false })
        )
        .subscribe(
          (fileData) => {
            let nomeArquivo = `certificado_${codSeguro}.pdf`;
            this.utilService.salvarArquivo(fileData, nomeArquivo);
          },
          (error: HttpErrorResponse) => {
            this.toastr.error(error.error.ex);
          }
        )
  }

}
